import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../img/icon.png';
import _imports_1 from '../../img/order.png';
import _imports_2 from '../../img/browse.png';
import _imports_3 from '../../img/shopping-cart.png';
import _imports_4 from '../../img/user.png';
import _imports_5 from '../../img/english.png';
import _imports_6 from '../../img/chinese.png';
import _imports_7 from '../../img/icons/Ellipse.png';
import _imports_8 from '../../img/icons/available.png';
import _imports_9 from '../../img/icons/plus.png';
const _withScopeId = n => (_pushScopeId("data-v-00730e7e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "head"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = {
  class: "tab"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  class: "imglist"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popup-arrow"
}, null, -1));
const _hoisted_9 = {
  class: "popup-content"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popup-arrow"
}, null, -1));
const _hoisted_11 = {
  class: "user-card"
};
const _hoisted_12 = {
  class: "user-header"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1));
const _hoisted_14 = {
  class: "username"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_16 = {
  class: "menu-row"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  key: 1
};
const _hoisted_20 = {
  class: "order-row"
};
const _hoisted_21 = {
  class: "order-item"
};
const _hoisted_22 = {
  class: "num"
};
const _hoisted_23 = {
  key: 0,
  class: "label"
};
const _hoisted_24 = {
  key: 1,
  class: "label"
};
const _hoisted_25 = {
  class: "order-item"
};
const _hoisted_26 = {
  class: "num"
};
const _hoisted_27 = {
  key: 0,
  class: "label"
};
const _hoisted_28 = {
  key: 1,
  class: "label"
};
const _hoisted_29 = {
  class: "order-item"
};
const _hoisted_30 = {
  class: "num"
};
const _hoisted_31 = {
  key: 0,
  class: "label"
};
const _hoisted_32 = {
  key: 1,
  class: "label"
};
const _hoisted_33 = {
  class: "order-item"
};
const _hoisted_34 = {
  class: "num"
};
const _hoisted_35 = {
  key: 0,
  class: "label"
};
const _hoisted_36 = {
  key: 1,
  class: "label"
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popup-arrow"
}, null, -1));
const _hoisted_39 = {
  class: "empty-cart-box"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon-wrap"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
})], -1));
const _hoisted_41 = {
  class: "empty-text"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popup-arrow"
}, null, -1));
const _hoisted_43 = {
  class: "cart-content"
};
const _hoisted_44 = ["src"];
const _hoisted_45 = {
  class: "item-info"
};
const _hoisted_46 = {
  class: "item-name"
};
const _hoisted_47 = {
  class: "item-spec"
};
const _hoisted_48 = {
  class: "item-price"
};
const _hoisted_49 = {
  class: "cart-footer"
};
const _hoisted_50 = {
  class: "total-wrap"
};
const _hoisted_51 = {
  class: "total-text"
};
const _hoisted_52 = {
  class: "total-price"
};
const _hoisted_53 = {
  class: "address-box"
};
const _hoisted_54 = {
  class: "address-left"
};
const _hoisted_55 = {
  class: "name-phone"
};
const _hoisted_56 = {
  class: "address-detail"
};
const _hoisted_57 = {
  class: "address-right"
};
const _hoisted_58 = ["onClick"];
const _hoisted_59 = ["onClick"];
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1));
const _hoisted_61 = {
  class: "dialog-footer"
};
const _hoisted_62 = {
  class: "dialog-footer"
};
const _hoisted_63 = {
  class: "dialog-footer"
};
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popup-arrow"
}, null, -1));
const _hoisted_65 = {
  class: "order-content"
};
const _hoisted_66 = {
  class: "order-header"
};
const _hoisted_67 = {
  key: 0,
  class: "order-no"
};
const _hoisted_68 = {
  key: 1,
  class: "order-no"
};
const _hoisted_69 = {
  key: 2,
  class: "order-status"
};
const _hoisted_70 = {
  key: 3,
  class: "order-status"
};
const _hoisted_71 = {
  key: 4,
  class: "order-status"
};
const _hoisted_72 = {
  key: 5,
  class: "order-status"
};
const _hoisted_73 = {
  key: 6,
  class: "order-status"
};
const _hoisted_74 = {
  key: 7,
  class: "order-status"
};
const _hoisted_75 = ["src"];
const _hoisted_76 = {
  class: "goods-info"
};
const _hoisted_77 = {
  class: "goods-name"
};
const _hoisted_78 = {
  class: "goods-spec"
};
const _hoisted_79 = {
  class: "goods-price"
};
import { ref, reactive, onMounted, watch, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Search } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { regionData } from 'element-china-area-data';
import { useStore } from 'vuex';
import { getMessageConfig, getUserCartConfig, queryUserConfig, modifyPasswordConfig, getUserOrderStatusCountConfig, queryUserShippingListConfig, shippingInfodeleteConfig, shippingInfodetailConfig, shippingInfoupdateConfig, shippingInfoConfig, updateEmailConfig, queryUserOrderListConfig } from "../../api/home";
export default {
  __name: 'headTabbar',
  setup(__props) {
    const data = reactive({
      title: "",
      show: 0,
      tabList: [{
        name: "首页",
        englishName: "Home Page",
        index: 0
      }, {
        name: "产品分类",
        englishName: "Product Category",
        index: 1
      }, {
        name: "科研服务",
        englishName: "Research Services",
        index: 2
      }, {
        name: "关于我们",
        englishName: "About Us",
        index: 3
      }, {
        name: "购物指南",
        englishName: "Shopping Guide",
        index: 4
      }, {
        name: "联系方式",
        englishName: "Contact Information",
        index: 5
      }],
      input: "",
      pageNum: 1,
      pageSize: 100,
      clickItemBtnIndex: "",
      showPopup: false,
      username: "",
      dialogVisibleOne: false,
      dialogpassword: false,
      formData: {
        receiverName: '',
        receiverPhone: '',
        rangeInfo: [],
        addressDetail: '',
        isDefault: 1
      },
      formDataOne: {
        email: ''
      },
      formDataTwo: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        receiverName: [{
          required: true,
          message: '请输入收货人姓名',
          trigger: 'blur'
        }],
        receiverPhone: [{
          required: true,
          message: '请输入手机号码',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入正确的手机号码格式',
          trigger: 'blur'
        }],
        rangeInfo: [{
          required: true,
          message: '请选择所在地区',
          trigger: 'change'
        }],
        addressDetail: [{
          required: true,
          message: '请输入详细地址',
          trigger: 'blur'
        }]
      },
      rulesOne: {
        email: [{
          required: true,
          message: '请输入新的邮箱',
          trigger: 'blur'
        }, {
          type: 'email',
          message: '请输入正确的电子邮件地址',
          trigger: ['blur', 'change']
        }]
      },
      rulesTwo: {
        oldPassword: [{
          required: true,
          message: '请输入旧密码',
          trigger: 'blur'
        }
        // {
        //   pattern: /^\d{8,12}$/,
        //   message: '密码必须8-12位',
        //   trigger: 'blur'
        // }
        ],

        newPassword: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        }, {
          pattern: /^\d{8,12}$/,
          message: '密码必须8-12位',
          trigger: 'blur'
        }],
        confirmPassword: [{
          required: true,
          message: '请输入确认密码',
          trigger: 'blur'
        }, {
          pattern: /^\d{8,12}$/,
          message: '密码必须8-12位',
          trigger: 'blur'
        }]
      },
      switchShow: true
    });
    const route = useRoute();
    const router = useRouter();
    const visible = ref(false);
    const visibleOne = ref(false);
    const cartVisible = ref(false);
    const dialogVisible = ref(false);
    const visibleorder = ref(false);
    const areaOptions = ref(regionData);
    const store = useStore();
    const orderListOne = ref();

    // 级联选择器配置
    const cascaderProps = {
      value: 'label',
      label: 'label',
      children: 'children',
      checkStrictly: false,
      // 必须选到最后一级
      emitPath: true
    };
    // 功能菜单
    const menuList = ref([{
      name: '邮箱绑定',
      EnglishName: "Email"
    }, {
      name: '密码修改',
      EnglishName: "Password"
    }, {
      name: '地址管理',
      EnglishName: "Addresses"
    }, {
      name: '安全手机',
      EnglishName: "Phone"
    }]);

    // 订单状态数据
    const orderList = ref(null);
    watch(() => router.currentRoute.value, toPath => {
      if (toPath.name == 'home' || toPath.name == 'product' || toPath.name == 'service' || toPath.name == 'about' || toPath.name == 'shopping' || toPath.name == 'medium') {
        if (toPath.name == 'home') {
          data.show = 0;
          localStorage.setItem("headId", 0);
        }
        if (toPath.name == 'product') {
          data.show = 1;
          localStorage.setItem("headId", 1);
        }
        if (toPath.name == 'service') {
          data.show = 2;
          localStorage.setItem("headId", 2);
        }
        if (toPath.name == 'about') {
          data.show = 3;
          localStorage.setItem("headId", 3);
        }
        if (toPath.name == 'shopping') {
          data.show = 4;
          localStorage.setItem("headId", 4);
        }
        if (toPath.name == 'medium') {
          data.show = 5;
          localStorage.setItem("headId", 5);
        }
        if (localStorage.getItem("headId")) {
          data.show = localStorage.getItem("headId");
        } else {
          data.show = 0;
        }
      } else {
        data.show = null;
      }
      console.log(toPath, "toPath");

      // if (localStorage.getItem("headValueId")) {
      //   data.id = localStorage.getItem("headValueId")
      // }
    }, {
      immediate: true,
      deep: true
    });
    const tabBtn = index => {
      console.log(index, "asjasj");
      localStorage.setItem("headId", index);
      data.show = index;
      if (index == '0') {
        router.push({
          path: "/"
        });
      } else if (index == '1') {
        router.push({
          path: "/product"
        });
      } else if (index == '2') {
        router.push({
          path: "/service"
        });
      } else if (index == '3') {
        router.push({
          path: "/About"
        });
      } else if (index == '4') {
        router.push({
          path: "/shopping"
        });
      } else {
        router.push({
          path: "/medium"
        });
      }
    };
    const browseBtn = () => {
      data.showPopup = false;
      visible.value = false;
      visibleOne.value = false;
      cartVisible.value = false;
      dialogVisible.value = false;
      data.dialogVisibleOne = false;
      visibleorder.value = false;
      router.push({
        path: "/browse"
      });
    };
    const goLogin = () => {
      router.push({
        path: "/logIn",
        query: {
          activeTab: 0
        }
      });
    };
    const goRegister = () => {
      router.push({
        path: "/logIn",
        query: {
          activeTab: 1
        }
      });
    };
    const shoppingcartBtn = () => {
      data.showPopup = false;
      visible.value = false;
      visibleOne.value = false;
      cartVisible.value = false;
      dialogVisible.value = false;
      data.dialogVisibleOne = false;
      visibleorder.value = false;
      router.push({
        path: "/shoppingCart"
      });
    };
    const userBtn = () => {
      if (window.localStorage.getItem('xx_TOKENOne')) {
        queryUserConfig(window.localStorage.getItem('phone')).then(res => {
          data.username = res.data?.username;
          console.log(res, "as");
        });
        getUserOrderStatusCountConfig().then(res => {
          orderList.value = res.data;
          console.log(res, "as");
        });
        visible.value = true;
        data.showPopup = false;
        visibleOne.value = false;
        cartVisible.value = false;
        dialogVisible.value = false;
        data.dialogVisibleOne = false;
        visibleorder.value = false;
      } else {
        data.showPopup = true;
        visible.value = false;
        visibleOne.value = false;
        cartVisible.value = false;
        dialogVisible.value = false;
        data.dialogVisibleOne = false;
        visibleorder.value = false;
      }
    };
    const MyOrdersBtn = () => {
      data.showPopup = false;
      visible.value = false;
      visibleOne.value = false;
      cartVisible.value = false;
      dialogVisible.value = false;
      data.dialogVisibleOne = false;
      visibleorder.value = false;
      router.push({
        path: "/MyOrders"
      });
    };
    const goShop = () => {
      visibleOne.value = false;
      router.push({
        path: "/"
      });
    };

    // 退出登录事件
    const handleLogout = () => {
      visible.value = false;
      ElMessageBox.confirm('是否退出登录?', '退出登录!', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'none'
      }).then(() => {
        // window.localStorage.clear()
        localStorage.removeItem('xx_TOKENOne');
        localStorage.removeItem('phone');
        localStorage.setItem("headId", 0);
        router.push({
          path: "/"
        });
      }).catch(() => {});
      // 你的退出逻辑：清空token、跳转登录页
    };

    // 鼠标经过购物车
    const shoppingcartBtnOne = () => {
      if (window.localStorage.getItem('xx_TOKENOne')) {
        getUserCartConfig().then(res => {
          if (res.data && res.data.length >= 1) {
            res.data.map(item => {
              item.checked = false;
            });
            cartList.value = res.data;
            cartVisible.value = true;
            visibleOne.value = false;
            visible.value = false;
            data.showPopup = false;
            dialogVisible.value = false;
            data.dialogVisibleOne = false;
            visibleorder.value = false;
          } else {
            visibleOne.value = true;
            visible.value = false;
            data.showPopup = false;
            cartVisible.value = false;
            dialogVisible.value = false;
            data.dialogVisibleOne = false;
            visibleorder.value = false;
          }
        });
      }
    };

    // 购物车商品数据
    const cartList = ref([]);

    // 自动计算选中商品总价
    const totalMoney = computed(() => {
      return cartList.value.filter(item => item.checked).reduce((sum, item) => sum + Number(item.price), 0).toFixed(2);
    });

    // 原价划线
    // const originalPrice = ref('51295.00')

    // 跳转结算页面
    const goSettle = () => {
      const selectedItems = cartList.value.filter(item => item.checked);
      if (selectedItems.length === 0) {
        ElMessage.warning('请选择要结算的商品');
        return;
      }
      let param = {
        type: 2,
        cartItemIds: [],
        orderChannel: "1"
      };
      selectedItems.map(item => {
        param.cartItemIds.push(item.id);
      });
      console.log('结算商品：', param, selectedItems);
      cartVisible.value = false;
      router.push({
        path: "/OrderConfirm",
        query: {
          param: JSON.stringify(param)
        }
      });
      // 这里可以跳转到结算页，或者发起结算请求
      // ElMessage.success('跳转到结算页面')
    };

    // 地址弹出框按钮
    const menuBtn = val => {
      if (val == "地址管理") {
        queryUserShipping();
        dialogVisible.value = true;
        visible.value = false;
        data.showPopup = false;
        visibleOne.value = false;
        cartVisible.value = false;
        data.dialogVisibleOne = false;
        data.dialogmailbox = false;
        data.dialogpassword = false;
        visibleorder.value = false;
      }
      if (val == "邮箱绑定") {
        data.dialogmailbox = true;
        dialogVisible.value = false;
        visible.value = false;
        data.showPopup = false;
        visibleOne.value = false;
        cartVisible.value = false;
        data.dialogVisibleOne = false;
        data.dialogpassword = false;
        visibleorder.value = false;
      }
      if (val == "密码修改") {
        data.dialogpassword = true;
        dialogVisible.value = false;
        visible.value = false;
        data.showPopup = false;
        visibleOne.value = false;
        cartVisible.value = false;
        data.dialogVisibleOne = false;
        data.dialogmailbox = false;
        visibleorder.value = false;
      }
      if (val == "安全手机") {
        data.dialogpassword = true;
        dialogVisible.value = false;
        visible.value = false;
        data.showPopup = false;
        visibleOne.value = false;
        cartVisible.value = false;
        data.dialogVisibleOne = false;
        data.dialogmailbox = false;
        visibleorder.value = false;
      }
    };
    const queryUserShipping = () => {
      queryUserShippingListConfig().then(res => {
        if (res.resultCode == 200) {
          addressList.value = res.data;
        }
        console.log(res, "saas");
      });
    };

    // 地址数据
    const addressList = ref([]);
    // 表单ref
    const formRef = ref();
    const formRefOne = ref();
    const formRefTwo = ref();
    // 重置表单
    const resetForm = () => {
      formRef.value?.resetFields();
      Object.assign(data.formData, {
        receiverName: '',
        receiverPhone: '',
        rangeInfo: [],
        addressDetail: '',
        isDefault: 1
      });
    };

    // 重置表单
    const resetFormOne = () => {
      formRefOne.value?.resetFields();
      Object.assign(data.formDataOne, {
        receiverName: '',
        receiverPhone: '',
        rangeInfo: [],
        addressDetail: '',
        isDefault: 1
      });
    };

    // 重置表单
    const resetFormtwo = () => {
      formRefTwo.value?.resetFields();
      Object.assign(data.formDataTwo, {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      });
    };

    // 编辑地址
    const editAddress = item => {
      data.dialogVisibleOne = true;
      if (data.switchShow == true) {
        data.titleName = "编辑地址";
      } else {
        data.titleName = "Edit Address";
      }
      shippingInfodetailConfig(item.id).then(res => {
        if (res.resultCode == 200) {
          res.data.rangeInfo = res.data.rangeInfo.split(',');
          data.formData = res.data;
        }
        console.log(res, "saas");
      });
    };

    // 删除地址
    const deleteAddress = async id => {
      try {
        await ElMessageBox.confirm('确定要删除该收货地址吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        // 组装地址数据
        const param = {
          id: id
        };
        shippingInfodeleteConfig(param).then(res => {
          if (res.resultCode == 200) {
            ElMessage.success('地址删除成功！');
            queryUserShipping();
          }
          console.log(res, "saas");
        });
      } catch {
        // 用户取消删除
      }
    };

    // 保存地址
    const handleSave = async () => {
      // 表单校验
      await formRef.value.validate(valid => {
        if (valid) {
          if (data.formData.id) {
            // 组装地址数据
            const addressData = {
              receiverName: data.formData.receiverName,
              receiverPhone: data.formData.receiverPhone,
              // 拼接省市区
              rangeInfo: data.formData.rangeInfo.join(),
              addressDetail: data.formData.addressDetail,
              isDefault: data.formData.isDefault,
              id: data.formData.id
            };
            shippingInfoupdateConfig(addressData).then(res => {
              if (res.resultCode == 200) {
                ElMessage.success('地址修改成功！');
                data.dialogVisibleOne = false;
                queryUserShipping();
              }
              console.log(res, "saas");
            });
          } else {
            // 组装地址数据
            const addressData = {
              receiverName: data.formData.receiverName,
              receiverPhone: data.formData.receiverPhone,
              // 拼接省市区
              rangeInfo: data.formData.rangeInfo.join(),
              addressDetail: data.formData.addressDetail,
              isDefault: data.formData.isDefault
            };
            shippingInfoConfig(addressData).then(res => {
              if (res.resultCode == 200) {
                ElMessage.success('地址添加成功！');
                data.dialogVisibleOne = false;
                queryUserShipping();
              }
              console.log(res, "saas");
            });
          }
        } else {
          ElMessage.warning('请完善所有必填信息');
          return false;
        }
      });
    };
    const handleSaveemail = async () => {
      // 表单校验
      await formRefOne.value.validate(valid => {
        if (valid) {
          // 组装地址数据
          const addressData = {
            email: data.formDataOne.email
          };
          updateEmailConfig(addressData).then(res => {
            if (res.resultCode == 200) {
              ElMessage.success('修改绑定邮箱成功！');
              data.dialogmailbox = false;
              queryUserShipping();
            } else {
              ElMessage.error(res.resultMsg);
            }
            console.log(res, "saas");
          });
        } else {
          ElMessage.warning('请完善所有必填信息');
          return false;
        }
      });
    };
    const handleSavepassword = async () => {
      // 表单校验
      await formRefTwo.value.validate(valid => {
        if (valid) {
          if (data.formDataTwo.newPassword == data.formDataTwo.confirmPassword) {
            const addressData = {
              oldPassword: data.formDataTwo.oldPassword,
              newPassword: data.formDataTwo.newPassword,
              confirmPassword: data.formDataTwo.confirmPassword
            };
            modifyPasswordConfig(addressData).then(res => {
              if (res.resultCode == 200) {
                ElMessage.success('修改密码成功！');
                data.dialogpassword = false;
              } else {
                ElMessage.error(res.resultMsg);
              }
              console.log(res, "saas");
            });
          } else {
            ElMessage.error("密码不一致,请重新输入");
            return;
          }
        } else {
          ElMessage.warning('请完善所有必填信息');
          return false;
        }
      });
    };

    // 新增地址
    const handleAdd = () => {
      if (data.switchShow == true) {
        data.titleName = "新增地址";
      } else {
        data.titleName = "Add Address";
      }
      data.dialogVisibleOne = true;
      // ElMessage.info('打开新增地址弹窗')
    };

    const visibleorderbtn = () => {
      if (window.localStorage.getItem('xx_TOKENOne')) {
        visibleorder.value = true;
        data.dialogpassword = false;
        dialogVisible.value = false;
        visible.value = false;
        data.showPopup = false;
        visibleOne.value = false;
        cartVisible.value = false;
        data.dialogVisibleOne = false;
        data.dialogmailbox = false;
        treeSelect();
      }
    };
    const treeSelect = () => {
      let formData = {
        pageNum: 1,
        pageSize: 100000,
        orderStatus: ""
      };
      queryUserOrderListConfig(formData).then(res => {
        if (res.resultCode == 200) {
          orderListOne.value = res.data;
        }
        console.log(res, "saas");
      });
    };

    // 切换中英文
    const switchBtn = () => {
      data.switchShow = !data.switchShow;
      store.commit('SET_USER_INFO', data.switchShow);
    };
    onMounted(() => {// 代码逻辑0
      // treeSelect()
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.tabList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["name", data.show == index ? 'names' : 'name']),
          key: index,
          onClick: $event => tabBtn(index)
        }, [data.switchShow == true ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.name), 1)) : _createCommentVNode("", true), data.switchShow == false ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item.englishName), 1)) : _createCommentVNode("", true)], 10, _hoisted_4);
      }), 128))]), _createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
        src: _imports_1,
        alt: "",
        onClick: MyOrdersBtn,
        onMouseenter: visibleorderbtn
      }, null, 32), _createElementVNode("img", {
        src: _imports_2,
        onClick: browseBtn,
        alt: ""
      }), _createElementVNode("img", {
        src: _imports_3,
        alt: "",
        onClick: shoppingcartBtn,
        onMouseenter: shoppingcartBtnOne
      }, null, 32), _createElementVNode("img", {
        src: _imports_4,
        alt: "",
        onClick: userBtn
      }), data.switchShow == true ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _imports_5,
        alt: "",
        onClick: switchBtn
      })) : _createCommentVNode("", true), data.switchShow == false ? (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: _imports_6,
        alt: "",
        onClick: switchBtn
      })) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", {
        class: "popup",
        onMouseenter: _cache[0] || (_cache[0] = $event => data.showPopup = true),
        onMouseleave: _cache[1] || (_cache[1] = $event => data.showPopup = false)
      }, [_hoisted_8, _createElementVNode("div", _hoisted_9, [data.switchShow == true ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "popup-item",
        onClick: goLogin
      }, "登录")) : _createCommentVNode("", true), data.switchShow == true ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "popup-item",
        onClick: goRegister
      }, "注册")) : _createCommentVNode("", true), data.switchShow == false ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "popup-item",
        onClick: goLogin
      }, "Login")) : _createCommentVNode("", true), data.switchShow == false ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: "popup-item",
        onClick: goRegister
      }, "Register")) : _createCommentVNode("", true)])], 544), [[_vShow, data.showPopup]]), _withDirectives(_createElementVNode("div", {
        class: "popoverBox",
        onMouseenter: _cache[2] || (_cache[2] = $event => visible.value = true),
        onMouseleave: _cache[3] || (_cache[3] = $event => visible.value = false)
      }, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("span", _hoisted_14, _toDisplayString(data?.username), 1)]), _hoisted_15, _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "menu-item",
          key: item.name,
          onClick: $event => menuBtn(item.name)
        }, [data.switchShow == true ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(item.name), 1)) : _createCommentVNode("", true), data.switchShow == false ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(item.EnglishName), 1)) : _createCommentVNode("", true)], 8, _hoisted_17);
      }), 128))]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, _toDisplayString(orderList.value?.unPaidNum), 1), data.switchShow == true ? (_openBlock(), _createElementBlock("div", _hoisted_23, "待付款")) : _createCommentVNode("", true), data.switchShow == false ? (_openBlock(), _createElementBlock("div", _hoisted_24, "To Pay")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString(orderList.value?.shippedNum), 1), data.switchShow == true ? (_openBlock(), _createElementBlock("div", _hoisted_27, "待收货")) : _createCommentVNode("", true), data.switchShow == false ? (_openBlock(), _createElementBlock("div", _hoisted_28, "To Receive")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, _toDisplayString(orderList.value?.completedNum), 1), data.switchShow == true ? (_openBlock(), _createElementBlock("div", _hoisted_31, "已完成")) : _createCommentVNode("", true), data.switchShow == false ? (_openBlock(), _createElementBlock("div", _hoisted_32, "Completed")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, _toDisplayString(orderList.value?.cancelledNum), 1), data.switchShow == true ? (_openBlock(), _createElementBlock("div", _hoisted_35, "已取消")) : _createCommentVNode("", true), data.switchShow == false ? (_openBlock(), _createElementBlock("div", _hoisted_36, "Canceled")) : _createCommentVNode("", true)])]), _hoisted_37, data.switchShow == true ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "logout",
        onClick: handleLogout
      }, "退出登录")) : _createCommentVNode("", true), data.switchShow == false ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "logout",
        onClick: handleLogout
      }, "Log Out")) : _createCommentVNode("", true)])], 544), [[_vShow, visible.value]]), _withDirectives(_createElementVNode("div", {
        class: "popoverBoxOne",
        onMouseenter: _cache[4] || (_cache[4] = $event => visibleOne.value = true),
        onMouseleave: _cache[5] || (_cache[5] = $event => visibleOne.value = false)
      }, [_hoisted_38, _createElementVNode("div", _hoisted_39, [_hoisted_40, _createElementVNode("p", _hoisted_41, _toDisplayString(data.switchShow == true ? '购物车还是空的，快去选购吧！' : 'Your cart is empty! Start shopping now!'), 1), _createVNode(_component_el_button, {
        type: "primary",
        class: "go-shop-btn",
        onClick: goShop
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(data.switchShow == true ? '去逛逛' : 'Shop Now'), 1)]),
        _: 1
      })])], 544), [[_vShow, visibleOne.value]]), _withDirectives(_createElementVNode("div", {
        class: "popoverBoxTwo",
        onMouseenter: _cache[6] || (_cache[6] = $event => cartVisible.value = true),
        onMouseleave: _cache[7] || (_cache[7] = $event => cartVisible.value = false)
      }, [_hoisted_42, _createElementVNode("div", _hoisted_43, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cartList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "cart-item",
          key: item.id
        }, [_createVNode(_component_el_checkbox, {
          modelValue: item.checked,
          "onUpdate:modelValue": $event => item.checked = $event
        }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createElementVNode("img", {
          src: item.baseImage,
          class: "item-img"
        }, null, 8, _hoisted_44), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, _toDisplayString(item.productName), 1), _createElementVNode("div", _hoisted_47, _toDisplayString(item.productPackaging), 1)]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", null, "¥" + _toDisplayString(item.price), 1), _createElementVNode("div", null, "×" + _toDisplayString(item.number), 1)])]);
      }), 128)), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, _toDisplayString(data.switchShow == true ? '总计：' : 'Total：'), 1), _createElementVNode("div", _hoisted_52, _toDisplayString(totalMoney.value), 1)]), _createVNode(_component_el_button, {
        type: "primary",
        class: "settle-btn",
        onClick: goSettle
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(data.switchShow == true ? '结算' : 'Checkout'), 1)]),
        _: 1
      })])])], 544), [[_vShow, cartVisible.value]])]), _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => dialogVisible.value = $event),
        title: data.switchShow == true ? '地址管理' : 'Address Management',
        width: "720px",
        "close-on-click-modal": false,
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_53, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addressList.value, item => {
          return _openBlock(), _createElementBlock("div", {
            class: "address-item",
            key: item.id
          }, [_createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, _toDisplayString(item.receiverName) + "  " + _toDisplayString(item.receiverPhone), 1), _createElementVNode("div", _hoisted_56, _toDisplayString(item.rangeInfo + item.addressDetail), 1)]), _createElementVNode("div", _hoisted_57, [_createElementVNode("span", {
            class: "edit",
            onClick: $event => editAddress(item)
          }, _toDisplayString(data.switchShow == true ? '编辑' : 'Edit'), 9, _hoisted_58), _createElementVNode("span", {
            class: "del",
            onClick: $event => deleteAddress(item.id)
          }, _toDisplayString(data.switchShow == true ? '删除' : 'Delete'), 9, _hoisted_59)])]);
        }), 128)), _createElementVNode("div", {
          class: "add-address",
          onClick: handleAdd
        }, [_hoisted_60, _createElementVNode("span", null, _toDisplayString(data.switchShow == true ? '新增收货地址' : 'Add New Address'), 1)])])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_el_dialog, {
        modelValue: data.dialogVisibleOne,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => data.dialogVisibleOne = $event),
        title: data.titleName,
        width: "600px",
        "close-on-click-modal": false,
        onClose: resetForm,
        center: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_61, [_createVNode(_component_el_button, {
          onClick: _cache[14] || (_cache[14] = $event => data.dialogVisibleOne = false)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(data.switchShow == true ? '取消' : 'Cancel'), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSave
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(data.switchShow == true ? '保存' : 'save'), 1)]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: data.formData,
          rules: data.rules,
          "label-width": "120px",
          class: "address-form"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: data.switchShow == true ? '收货人' : 'Consignee',
            prop: "receiverName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.formData.receiverName,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => data.formData.receiverName = $event),
              placeholder: "请输入收货人姓名"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: data.switchShow == true ? '手机号码' : 'Phone',
            prop: "receiverPhone"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.formData.receiverPhone,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => data.formData.receiverPhone = $event),
              placeholder: "请输入手机号码",
              maxlength: "11",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: data.switchShow == true ? '所在地区' : 'Location',
            prop: "rangeInfo"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_cascader, {
              modelValue: data.formData.rangeInfo,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => data.formData.rangeInfo = $event),
              options: areaOptions.value,
              props: cascaderProps,
              placeholder: "点击选择地区",
              clearable: "",
              style: {
                "width": "100%"
              }
            }, null, 8, ["modelValue", "options"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: data.switchShow == true ? '详细地址' : 'Address',
            prop: "addressDetail"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.formData.addressDetail,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => data.formData.addressDetail = $event),
              type: "textarea",
              rows: 3,
              placeholder: "点击输入详细地址"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: data.switchShow == true ? '是否默认地址' : 'Default',
            prop: "isDefault"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: data.formData.isDefault,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => data.formData.isDefault = $event),
              "active-value": 1,
              "inactive-value": 0,
              "inline-prompt": "",
              "active-text": data.switchShow == true ? '是' : 'is',
              "inactive-text": data.switchShow == true ? '否' : 'No'
            }, null, 8, ["modelValue", "active-text", "inactive-text"])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_el_dialog, {
        modelValue: data.dialogmailbox,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => data.dialogmailbox = $event),
        title: data.switchShow == true ? '修改绑定邮箱' : 'Change Email',
        width: "600px",
        "close-on-click-modal": false,
        onClose: resetFormOne,
        center: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_62, [_createVNode(_component_el_button, {
          onClick: _cache[17] || (_cache[17] = $event => data.dialogmailbox = false)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(data.switchShow == true ? '取消' : 'Cancel'), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSaveemail
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(data.switchShow == true ? '保存' : 'save'), 1)]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRefOne",
          ref: formRefOne,
          model: data.formDataOne,
          rules: data.rulesOne,
          "label-width": "120px",
          class: "address-form"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: data.switchShow == true ? '新的邮箱' : 'New Email',
            prop: "email"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.formDataOne.email,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => data.formDataOne.email = $event),
              placeholder: "请输入新的邮箱"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_el_dialog, {
        modelValue: data.dialogpassword,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => data.dialogpassword = $event),
        title: data.switchShow == true ? '修改密码' : 'Change Password',
        width: "600px",
        "close-on-click-modal": false,
        onClose: resetFormtwo,
        center: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_63, [_createVNode(_component_el_button, {
          onClick: _cache[22] || (_cache[22] = $event => data.dialogpassword = false)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(data.switchShow == true ? '取消' : 'Cancel'), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSavepassword
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(data.switchShow == true ? '保存' : 'save'), 1)]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRefTwo",
          ref: formRefTwo,
          model: data.formDataTwo,
          rules: data.rulesTwo,
          "label-width": "145px",
          class: "address-form"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: data.switchShow == true ? '旧密码' : 'Old Password',
            prop: "oldPassword"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.formDataTwo.oldPassword,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => data.formDataTwo.oldPassword = $event),
              type: "password",
              placeholder: "请输入旧密码"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: data.switchShow == true ? '新密码' : 'New Password',
            prop: "newPassword"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.formDataTwo.newPassword,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => data.formDataTwo.newPassword = $event),
              type: "password",
              placeholder: "请输入新密码"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: data.switchShow == true ? '确认密码' : 'Confirm Password',
            prop: "confirmPassword"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.formDataTwo.confirmPassword,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => data.formDataTwo.confirmPassword = $event),
              type: "password",
              placeholder: "请输入确认密码"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"]), _withDirectives(_createElementVNode("div", {
        class: "popoverorderOne",
        onMouseenter: _cache[24] || (_cache[24] = $event => visibleorder.value = true),
        onMouseleave: _cache[25] || (_cache[25] = $event => visibleorder.value = false)
      }, [_hoisted_64, _createElementVNode("div", _hoisted_65, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderListOne.value, order => {
        return _openBlock(), _createElementBlock("div", {
          class: "order-group",
          key: order.orderNo
        }, [_createElementVNode("div", _hoisted_66, [data.switchShow == true ? (_openBlock(), _createElementBlock("div", _hoisted_67, "订单号：" + _toDisplayString(order.orderNo), 1)) : _createCommentVNode("", true), data.switchShow == false ? (_openBlock(), _createElementBlock("div", _hoisted_68, "Order No：" + _toDisplayString(order.orderNo), 1)) : _createCommentVNode("", true), order.orderStatus == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_69, "未支付")) : _createCommentVNode("", true), order.orderStatus == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_70, "未发货")) : _createCommentVNode("", true), order.orderStatus == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_71, "已发货")) : _createCommentVNode("", true), order.orderStatus == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_72, "已完成")) : _createCommentVNode("", true), order.orderStatus == 4 ? (_openBlock(), _createElementBlock("span", _hoisted_73, "已取消")) : _createCommentVNode("", true), order.orderStatus == 6 ? (_openBlock(), _createElementBlock("span", _hoisted_74, "已退款")) : _createCommentVNode("", true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.orderItemsVoList, goods => {
          return _openBlock(), _createElementBlock("div", {
            class: "order-item",
            key: goods.id
          }, [_createElementVNode("img", {
            src: goods.productImage,
            class: "goods-img"
          }, null, 8, _hoisted_75), _createElementVNode("div", _hoisted_76, [_createElementVNode("div", _hoisted_77, _toDisplayString(goods.productName), 1), _createElementVNode("div", _hoisted_78, _toDisplayString(goods.productPackaging), 1)]), _createElementVNode("div", _hoisted_79, [_createElementVNode("div", null, "¥" + _toDisplayString(goods.unitPrice), 1), _createElementVNode("div", null, "×" + _toDisplayString(goods.number), 1)])]);
        }), 128))]);
      }), 128))])], 544), [[_vShow, visibleorder.value]])]);
    };
  }
};